import { stableStringify } from "@sail/utils";
import { simpleHash } from "../cachingUtils/simpleHash";
export function buildFetchKey(url, options, format) {
    var _options_requestKey;
    const requestKey = (_options_requestKey = options.requestKey) !== null && _options_requestKey !== void 0 ? _options_requestKey : '';
    const serialized = `${url}-${stableStringify({
        body: options.body,
        cache: options.cache,
        headers: options.headers,
        method: options.method,
        mode: options.mode,
        credentials: options.credentials,
        referrer: options.referrer,
        referrerPolicy: options.referrerPolicy,
        keepalive: options.keepalive,
        timeout: options.timeout,
        format
    })}-${requestKey}`;
    return simpleHash(serialized);
}

//# sourceMappingURL=requestHashing.js.map